
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, publishReplay, refCount, catchError, toArray } from 'rxjs/operators';
import { of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { LibService } from '@medlogic/shared/geform';
import { CadastroService } from '@medlogic/shared/shared-data-access';
import { GlobalService, LogService } from '@medlogic/shared/shared-interfaces';
import { ICareRoutine } from 'libs/shared/shared-interfaces/src/lib/interface/icare-routine';
import { CareRoutineService } from './care-routine.service';
import { ConfigStateService } from '@medlogic/shared/state-config';

@Injectable({
  providedIn: 'root'
})
export class CareRoutineCustomService extends CareRoutineService {

  constructor(
    http: HttpClient,
    cadastroSrv: CadastroService,
    glb: GlobalService,
    cnf: ConfigStateService,
    log: LogService,
    lib: LibService
  ) {
    super(http, cadastroSrv, glb, cnf, log, lib);
    try {
    } catch (error) {
      this.log.Registrar(this.constructor.name, 'constructor', error.message);
    }
  }

  getByIdAndPeriod(
    ano: number,
    patientId: string,
    dtStart: Date = null,
    dtEnd: Date = null,
    lstVariables?: string
  ): Observable<any> {
    try {
      this.cadastroNo = ano;
      const startDate = dtStart || new Date(1900, 0, 1);
      const endDate = dtEnd || new Date(2500, 0, 1);
      const filterStr = `V_28051:${patientId}`;

      return this.getFiltered(this.cadastroNo, filterStr, startDate, endDate, lstVariables).pipe(
        toArray(),
      );
    } catch (error) {
      this.log.Registrar(
        this.constructor.name,
        'getByIdAndPeriod',
        error.message
      );
    }
    return of(null);
  }

  /**
   * Retorna dados filtrando a query no bd. strFilter é do tipo: `V_2230:${patientId}`.
   * Também filtra especificamente a dataavaliacao dentro do período.
   */
  protected getFiltered(
    cadastroNo: number,
    strFilter: string,
    startDate: Date,
    endDate: Date,
    lstVariables?: string
  ): Observable<ICareRoutine> {
    try {
      this.cadastroSrv.dtInicial = this.glb.dateToYYYYMMddThhmmss(startDate);
      this.cadastroSrv.dtFinal = this.glb.dateToYYYYMMddThhmmss(endDate);

      return this.cadastroSrv
        .getCadastroComFiltro(cadastroNo, lstVariables || this.lstVariaveis, strFilter, true)
        .pipe(
          map((c) => this.toAttribute(c)),
          publishReplay(),
          refCount()
        );
    } catch (error) {
      this.log.Registrar(this.constructor.name, 'getFiltered', error.message);
    }
    return of(null);
  }

  sortByDate = () =>
    map((v: ICareRoutine[]) =>
      v.sort((a, b) =>
        b.dataEvolucao && a.dataEvolucao
          ? this.glb.compareDates(a.dataEvolucao, b.dataEvolucao)
          : 0
      )
    );

  /* OBS: Usado apenas pelo card-prescription. */
  getFromCadastroFiltro(
    cadastroNo: number,
    filtro: string,
    startDate: Date,
    endDate: Date
  ): Observable<any> {
    try {
      this.cadastroSrv.dtInicial = this.glb.dateToYYYYMMddThhmmss(startDate);
      this.cadastroSrv.dtFinal = this.glb.dateToYYYYMMddThhmmss(endDate);

      return this.cadastroSrv
        .getCadastroComFiltro(
          cadastroNo,
          this.lstVariaveis,
          filtro,
          true,
          startDate,
          endDate
        )
        .pipe(
          map((c) => this.toAttribute(c)),
          publishReplay(),
          refCount()
        );
    } catch (error) {
      this.log.Registrar(
        this.constructor.name,
        'getFromCadatro',
        error.message
      );
    }
    return of(null);
  }

  /* Check se está fora da referência. */
  protected isOutOfRef(value: number, minRef: number, maxRef: number): boolean {
    try {
      return value < minRef || value > maxRef;
    } catch (error) {
      this.log.Registrar(this.constructor.name, 'isOutOfRef', error.message);
    }
    return false;
  }

  mapObjToEvolucaoFisioterapia(obj: {
    [key: string]: string | Date | number;
  }): Observable<ICareRoutine> {
    try {
      return of(obj).pipe(this.mapTo());
    } catch (error) {
      this.log.Registrar(
        this.constructor.name,
        'mapObjToVitalSign',
        error.message
      );
    }
    return of(null);
  }

  private mapTo = () => map((c: any) => this.toAttribute(c));

  getLocationByMedlogicId(medlogicId): Observable<any> {
    try {
      const startDate = new Date(1900, 0, 1);
      const endDate = new Date(2500, 0, 1);
      const filter = `V_28051:${medlogicId}`;

      return this.getFiltered(this.cadastroNo, filter, startDate, endDate).pipe(
        map((a) => a),
        toArray(),
        map((mov: any) => {
          let latestMov = {};
          for (let i = 0; i < mov.length; i += 1) {
            const prontuarioMEDLOGIC = mov[i].prontuarioMEDLOGIC;
            const date = new Date(mov[i].dataEvolucao);
            const andar = mov[i].andar;
            const bloco = mov[i].bloco;
            const quarto = mov[i].quarto;
            if (
              !latestMov[prontuarioMEDLOGIC] ||
              latestMov[prontuarioMEDLOGIC].date < date
            ) {
              latestMov[prontuarioMEDLOGIC] = {
                prontuarioMEDLOGIC,
                date,
                andar,
                bloco,
                quarto,
              };
            }
          }
          return Object.values(latestMov);
        }),
        map((array) => array[0]),
        publishReplay(),
        refCount()
      );
    } catch (error: any) {
      this.log.Registrar(this.constructor.name, 'getByFloor', error.message);
    }
  }
}
